// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts

export let EvaluationReason = /*#__PURE__*/function (EvaluationReason) {
  EvaluationReason["Error"] = "Error";
  EvaluationReason["LocalOverride"] = "LocalOverride";
  EvaluationReason["Unrecognized"] = "Unrecognized";
  EvaluationReason["Uninitialized"] = "Uninitialized";
  EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
  EvaluationReason["Network"] = "Network";
  EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
  EvaluationReason["Bootstrap"] = "Bootstrap";
  EvaluationReason["Cache"] = "Cache";
  EvaluationReason["Unknown"] = "Unknown";
  return EvaluationReason;
}({});

// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts